import { Component } from '@angular/core';

@Component({
  selector: 'app-shipping-returns',
  templateUrl: './shipping-returns.component.html',
  styleUrls: ['./shipping-returns.component.css']
})
export class ShippingReturnsComponent {

}
